import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { 
  EventPublishingSettingsCreationAndUpdateModel 
} from "../models/event-publishing-settings/event-publishing-settings-creation-and-update.model";
import { EventPublishingSettingsModel } from "../models/event-publishing-settings/event-publishing-settings.model";
import { Configuration } from "src/assets/Configuration";

@Injectable({
  providedIn: 'root'
})
export class EventPublishingSettingsService {

  constructor(private httpClient: HttpClient) {}

  getEventPublishingSettings(): Observable<EventPublishingSettingsModel | null> {
    return this.httpClient.get<EventPublishingSettingsModel | null>(
      Configuration.getApiBaseUrl() + '/event-publishing-settings'
    );
  }

  upsertEventPublishingSettings(
    model: EventPublishingSettingsCreationAndUpdateModel
  ): Observable<EventPublishingSettingsModel> {
    return this.httpClient.put<EventPublishingSettingsModel>(
      Configuration.getApiBaseUrl() + '/event-publishing-settings', 
      model
    );
  }

  deleteEventPublishingSettings(): Observable<void> {
    return this.httpClient.delete<void>(
      Configuration.getApiBaseUrl() + '/event-publishing-settings'
    );
  }
}